import App from 'app/app.js';
import 'app/service/PostalCodeValidationService.js';

function LtPostalCodeValidationDirective(PostalCodeValidationService) {
  return {
    restrict: 'A',
    require: 'ngModel',
    link: function (scope, element, attrs, ctrl) {
      var validate = function (stateProvince, postalCode) {
        var valid = PostalCodeValidationService.postalCodeValidator(stateProvince, postalCode);
        // set params
        ctrl.value = postalCode;
        ctrl.stateProvince = stateProvince;
        return valid;
      };

      var unwatch = scope.$watch(attrs.ltStateProvince, function () {
        //If PostalCode and StateProvince combination is incorrect,
        //on correcting StateProvince modelValue of PostalCode needs to be set.
        ctrl.$validate();
      });

      ctrl.$validators.ltPostalCode = function (modelValue, viewValue) {
        return !!validate(scope.$eval(attrs.ltStateProvince), viewValue);
      };

      scope.$on('$destroy', function () {
        unwatch();
      });
    }
  };
}

App.directive('ltPostalCode', ['PostalCodeValidationService', LtPostalCodeValidationDirective]);
